import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TaxonomyI18nModule } from '@vendasta/taxonomy-i18n';
import { EmptyStateModule, VaBadgeModule } from '@vendasta/uikit';
import { RecaptchaModule } from 'ng-recaptcha';
import { NgChartsModule } from 'ng2-charts';
import { CookieService } from 'ngx-cookie-service';
import { GooglePlacesService } from '../core/google-places/google-places.service';
import { PublicSignupComponent } from './public-signup.component';
import { RegistrationCompleteDialogComponent } from './registration-complete-dialog/registration-complete-dialog.component';

@NgModule({
  imports: [
    RouterModule.forChild([{ path: 'business/:partnerId/sign-up', component: PublicSignupComponent }]),
    RouterModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    MatProgressBarModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatToolbarModule,
    NgChartsModule,
    MatAutocompleteModule,
    MatTooltipModule,
    MatIconModule,
    TranslateModule,
    TaxonomyI18nModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    EmptyStateModule,
    MatDialogModule,
    VaBadgeModule,
    RecaptchaModule,
  ],
  declarations: [PublicSignupComponent, RegistrationCompleteDialogComponent],
  exports: [
    PublicSignupComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
  ],
  providers: [GooglePlacesService, CookieService],
})
export class PublicSignUpModule {}
